import {
  forwardRef,
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
} from 'react';
import './action-menu.scss';

export const ActionMenus = forwardRef(
  (
    {
      //editUserHandler,
      //duplicateUserHandler,
      //resetPasswordHandler,
      //resendRegistrationEmailHandler,
      //editOrDuplicateUser,
      //status,
      //restPassword
      MenuLabelComponent,
      menuItems = [],
      containerClassName = '',
      menuItemContainerClassName = '',
    },
    ref,
  ) => {
    const actionMenusItemsRef = useRef(null);
    const [showMenu, setShowMenu] = useState(false);

    //on menu item click
    //const onMenuItemClickHandler = (e) => {
    //e.stopPropagation();
    //setShowMenu(false);
    //};

    //for handling menu show/hide events
    useEffect(() => {
      const onDocumentClickHandler = (e) => {
        if (showMenu && ref.current && !ref.current.contains(e.target)) {
          setShowMenu(false);
        }
      };

      document.addEventListener('mousedown', onDocumentClickHandler);

      return () => {
        //Cleanup the event listener
        document.removeEventListener('mousedown', onDocumentClickHandler);
      };
    }, [showMenu]);

    //Handle window resize
    useLayoutEffect(() => {
      function handleResize() {
        if (ref && ref.current) {
          //const top = ref.current.getBoundingClientRect().top;
          const height = ref.current.getBoundingClientRect().height;
          if (actionMenusItemsRef && actionMenusItemsRef.current) {
            actionMenusItemsRef.current.style.top = height + 'px';
          }
        }
      }

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [ref, actionMenusItemsRef]);

    return (
      <>
        {/*showActionPanel && */}
        <div
          className={`action-menu-container ${containerClassName}`}
          ref={ref}
          onClick={() => {
            setShowMenu(!showMenu);
          }}
        >
          {MenuLabelComponent && (
            <div className="d-flex">
              <MenuLabelComponent />
            </div>
          )}
          <div
            className={`action-menu-item-container ${
              showMenu ? 'show' : ''
            } ${menuItemContainerClassName}`}
            ref={actionMenusItemsRef}
          >
            {menuItems.map((MenuItem, index) => {
              return (
                <div key={index} className="action-menu-item">
                  <MenuItem />
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  },
);
